export const CLIENT_ROUTE = '/artist';
export const API_ROUTE = '/api/artist';
export const CLIENT_TITLE = 'Уран бүтээлч';

export type ArtistTitle =
    'Дуучин'
    | 'МУСТА'
    | 'МУГЖ'
    | 'МУУГЗ'
    | 'МУАЖ'

export const artistTitles: ArtistTitle[] = [
    'Дуучин',
    'МУСТА',
    'МУГЖ',
    'МУУГЗ',
    'МУАЖ',
]
